<template>
  <div class="how-it-works">
    <Navbar />
    <div class="my-5 pb-4"></div>
    <div class="container py-5">
      <div class="row pb-5">
        <div class="col-12 col-md-6 col-lg-4 text-left pb-5">
          <div class="hiw-home-1">
            <h3 class="font-weight-bolder text-capitalize kova-text">
              How can we help
            </h3>
            <h5 class="font-weight-bolder kova-text">
              What Can I Hire Talents For?
            </h5>
            <p class="pt-2 pb-4 ">
              You can hire talents for a host of jobs that you want to get done:
            </p>
            <ul>
              <li class="">Ideas that you want products for;</li>
              <li class="">Your on-going projects;</li>
              <li class="">Tasks that require top talents;</li>
              <li class="">Expansion of your project team;</li>
              <li class="">Building of your team from the scratch and more.</li>
            </ul>
            <div class="d-flex ml-4 mt-4">
              <div class="">
                <router-link to="/how-it-works">
                  <button
                    class="btn-kovatek ctrl-size rounded py-2 mr-3"
                    style="width: 150px"
                  >
                    Hiring Talents
                  </button>
                </router-link>
              </div>
              <div class="">
                <router-link to="/dev-how-it-works">
                  <button
                    class="btn-outline-kovatek ctrl-size rounded py-2"
                    style="width: 150px"
                  >
                    Working as Talent
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-8 text-left pb-5">
          <div class="hiw-home pt-5 pt-md-0">
            <div class="hiw-home-img-1"></div>
            <div class="hiw-home-img-2"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid hiw-second py-5">
      <div class="container px-md-5">
        <div class="px-lg-5">
          <h5 class="font-weight-bolder text-capitalize kova-text pb-3">
            TalentAlt deploys talents and tools to make your product building a
            seamless, speedy and convenient exercise for you.
          </h5>
          <p class="pb-3">
            We offer extensive services on software development for every job
            that you can think of and we thoroughly screen our talents for every
            of these services to enable you get the best remote hiring
            experience.
          </p>
          <router-link to="/hire">
            <button class="btn-kovatek ctrl-size rounded px-4 py-2">
              Post a Job
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="container-fluid kova-bg py-5">
      <div class="container text-white">
        <h4 class="font-weight-bolder text-capitalize text-white pt-4 pb-5">
          how it works
        </h4>
        <div class="row pb-5">
          <div class="col-12 col-md-6 text-left">
            <div class="py-4">
              <ul class="StepProgress">
                <li class="StepProgress-item numbered current">
                  <div class="pt-1 pb-4">
                    <h6 class="font-weight-bolder text-white">
                      Tell Us About Your Hiring Needs Or Post A Project
                    </h6>
                    <ul>
                      <li class="">
                        What is your project about and what are your hiring
                        needs? Simply tell us about it.
                      </li>
                      <li class="">
                        If you are uncertain about the requirements needed,
                        don’t fret, an account manager is available to guide you
                        through the skill set requirements that you’ll need for
                        your proposed project.
                      </li>
                      <li class="">
                        Posting of jobs is absolutely free. In no time, expert
                        developers will reach out to you.
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="StepProgress-item numbered current">
                  <div class="pt-1 pb-4">
                    <h6 class="font-weight-bolder text-white">
                      Scan Through Experts
                    </h6>
                    <ul>
                      <li class="">
                        Developers will submit proposals to work on your
                        project.
                      </li>
                      <li class="">
                        You can assess any developer of your choice. View their
                        profiles, ratings and reviews as well as their
                        skill-score.
                      </li>
                      <li class="">
                        Interview the developer by sending a direct message to
                        get more detail on how is going to work satisfactorily
                        on your project or with your team. You can take it a
                        step further by sending a direct to the developer to
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="StepProgress-item numbered current">
                  <div class="pt-1 pb-4">
                    <h6 class="font-weight-bolder text-white">
                      Fund Your Project Account
                    </h6>
                    <p class="">
                      At this stage, you’ll need to fund your project account
                      (with at least the first milestone fee for the project
                      execution) based on your budget so you can get started.
                    </p>
                  </div>
                </li>
                <li class="StepProgress-item numbered current">
                  <div class="pt-1 pb-4">
                    <h6 class="font-weight-bolder text-white">
                      Hire one or more developers and track their progress on
                      one board
                    </h6>
                    <ul>
                      <li class="">
                        Once your project account is funded, you can get ahead
                        with hiring your choice developer(s).
                      </li>
                      <li class="">
                        Make use of TalentAlt project board to keep track of the
                        activities and progress of your developer(s) on your
                        project.
                      </li>
                      <li class="">
                        Use TalentAlt project board to enable your developers
                        (if more than one) to collaborate on your project.
                      </li>
                      <li class="">
                        Communicate with developers using your project slack
                        organization that is integrated with your project board.
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="StepProgress-item numbered current">
                  <div class="pt-1 pb-4">
                    <h6 class="font-weight-bolder text-white">
                      Initiate payment when satisfied with job done
                    </h6>
                    <ul>
                      <p class="">
                        When a task or project is completed by your hired
                        developers and you are satisfied, make payment to the
                        developer(s) through milestone goals you have set with
                        your developer
                      </p>
                    </ul>
                  </div>
                </li>
                <li class="StepProgress-item"></li>
                <div class="ml-5">
                  <router-link to="/hire">
                    <button
                      class="btn-outline-kovatek ctrl-size rounded px-3 py-2 ml-5"
                    >
                      Post a Job
                    </button>
                  </router-link>
                </div>
              </ul>
            </div>
            <!-- <a-steps :current="current" @change="onChange" direction="vertical">
                            <a-step title="Step 1" description="This is a description." />
                            <a-step title="Step 2" description="This is a description." />
                            <a-step title="Step 3" description="This is a description." />
                        </a-steps> -->
          </div>
          <div class="col-12 col-md-6">
            <div class="vp-middle">
              <div class="mb-5">
                <div class="green-rounded-1"></div>
                <div class="hiw-steps-img-1 mt-5"></div>
                <div class="path-1"></div>
              </div>
              <div class="">
                <div class="green-rounded-2"></div>
                <div class="hiw-steps-img-2 mt-5"></div>
                <div class="path-2"></div>
              </div>
              <div class="">
                <div class="green-rounded-3"></div>
                <div class="hiw-steps-img-3 mt-5"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container py-5">
      <div class="row">
        <div class="col-12 col-md-6 text-left pb-5">
          <h3 class="font-weight-bolder text-capitalize kova-text">
            Crowdsource your project
          </h3>
          <p class="">
            Not having the needed funds to hire talents for your project is a
            problem facing start-ups and potential founders. TalentAlt has found
            a means of leveraging on its vast community of software talents who
            are interested in expanding their portfolio and gaining some
            real-life experience on software development to kick start and help
            build your product. Your product can come to life without running
            helter-skelter.
          </p>
          <p class="">
            Crowd-sourcing process involves simple, easy-to-do steps that can
            get you started on building your product.
          </p>
          <p class="font-weight-bolder">
            All you have to do is:
          </p>
          <p class="font-weight-bolder kova-text">Submit project</p>
          <p class="">
            On the platform you’ll see the crowd-source option, click on it and
            it would take you through the procedure of submitting a project.
          </p>
          <p class="font-weight-bolder kova-text">
            Developers vote on your porject
          </p>
          <p class="">
            This will call for you to give a while for developers on the
            platform to vote for yours and a couple of other projects to
            ascertain which projects would be approved to be listed on the
            crowd-source page
          </p>
          <p class="font-weight-bolder kova-text">
            Get your product building started
          </p>
          <p class="">
            Once your project is approved, you’ll be requested to pay a minimum
            flat fee for your project to be listed on the crowd-source page. As
            soon as this is done, interested developers will start submitting
            bids to work on your project. It is safe to say, you are on your way
            to eventuating your idea.
          </p>
          <p class="">
            Crowdsourcing service on TalentAlt requires agreeing to its
            <router-link to="/"> terms & conditions </router-link> and its
            binding agreement.
          </p>
        </div>
        <div class="col-12 col-md-6 pb-5">
          <div class="hiw-phone">
            <div class="green-circle"></div>
            <div class="blue-circle"></div>
            <div class="hiw-phone-img"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container py-5">
      <div class="row pb-5 flex-row-reverse">
        <div class="col-12 col-md-6 text-left pb-5">
          <h3 class="font-weight-bolder text-capitalize kova-text">
            Secure, Easy And Safe
          </h3>
          <p class="">
            TalentAlt ensures your activities are safe. We make security a top
            priority, it is very essential for us to protect your work and
            investment.
          </p>
          <ul class="">
            <li class="">
              We make sure that all transactions on the platform are secured.
            </li>
            <li class="">
              You pay for your project using a milestone payment agreement
              method
            </li>
            <li class="">
              Our support teams are available 24/7 to assist and guide you.
            </li>
            <li class="">
              We work as a community for growth and provide support and
              assistance
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-6 text-left pb-5">
          <div class="hiw-lock">
            <div class="blue-rounded"></div>
            <div class="hiw-ellipse-img"></div>
            <div class="hiw-lock-img"></div>
          </div>
        </div>
      </div>
    </div>
    <GetHired />
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import GetHired from '@/components/GetHired.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'how-it-works',
  components: {
    Navbar,
    Footer,
    GetHired,
  },
  data() {
    return {
      current: 0,
    };
  },
  methods: {
    onChange(current) {
      // console.log('onChange:', current);
      this.current = current;
    },
  },
};
</script>

<style scoped>
p,
li,
.ctrl-size {
  font-size: 12px;
}
.vp-head {
  text-shadow: -1px 0 #20409a, 0 1px #20409a, 1px 0 #20409a, 0 -1px #20409a,
    -1px -1px #20409a, 1px 1px #20409a, -1px 1px #20409a, 1px -1px #20409a;
}
.it-works-btn {
  border: 0;
  outline: 0;
  height: 35px;
  width: 135px;
  font-size: 12px;
  color: #fff;
  border-radius: 30px;
}
.hiw-home {
  height: 340px;
}
.hiw-home-img-1 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-004.png');
  left: 100px;
  z-index: 4;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 380px;
  height: 350px;
}
.hiw-home-img-2 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-005.png');
  left: 400px;
  top: 80px;
  z-index: 2;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 320px;
  height: 200px;
}
.hiw-second {
  background-color: #c0e4d8;
}
.wrapper {
  width: 330px;
  font-family: 'Helvetica';
  font-size: 14px;
  border: 1px solid #ccc;
}
.StepProgress {
  position: relative;
  padding-left: 45px;
  list-style: none;
}
.StepProgress::before {
  display: inline-block;
  content: '';
  position: absolute;
  top: 0;
  left: 15px;
  width: 10px;
  height: 100%;
  border-left: 0px solid #ccc;
}
.StepProgress-item {
  position: relative;
}
.numbered {
  counter-increment: list;
}
.StepProgress-item:not(:last-child) {
  padding-bottom: 20px;
}
.StepProgress-item::before {
  display: inline-block;
  content: '';
  position: absolute;
  left: -15px;
  height: 100%;
  width: 10px;
}
.StepProgress-item::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
  left: -37px;
  width: 50px;
  height: 50px;
  border: 2px solid #ccc;
  border-radius: 50%;
  background-color: #fff;
}
.StepProgress-item.is-done::before {
  border-left: 1.5px solid #fff;
}
.StepProgress-item.is-done::after {
  content: '✔';
  font-size: 20px;
  padding-top: 10px;
  color: #fff;
  text-align: center;
  border: 1px solid #20409a;
  background-color: #20409a;
}
.StepProgress-item.current::before {
  border-left: 1.5px solid #fff;
}
.StepProgress-item.current::after {
  content: '0' counter(list);
  padding-top: 10px;
  width: 50px;
  height: 50px;
  top: -4px;
  left: -40px;
  font-size: 20px;
  text-align: center;
  color: #20409a;
  border: 1px solid #20409a;
  background-color: white;
}
.StepProgress-item > div {
  margin-left: 50px;
}
.vp-middle {
  height: 760px;
}
.hiw-steps-img-1 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-006.png');
  left: 100px;
  top: 40px;
  z-index: 2;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 400px;
  height: 260px;
}
.hiw-steps-img-2 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-007.png');
  left: 100px;
  top: 350px;
  z-index: 2;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 400px;
  height: 120px;
}
.hiw-steps-img-3 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-008.png');
  left: 100px;
  top: 520px;
  z-index: 2;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 400px;
  height: 260px;
}
.green-rounded-1 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-009.png');
  left: 390px;
  top: 170px;
  z-index: 4;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 220px;
  height: 85px;
}
.green-rounded-2 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-010.png');
  left: 0;
  top: 480px;
  z-index: 4;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 220px;
  height: 85px;
}
.green-rounded-3 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-011.png');
  left: 390px;
  top: 650px;
  z-index: 4;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 220px;
  height: 85px;
}
.path-1 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/path-001.png');
  left: 520px;
  top: 310px;
  z-index: 6;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 49px;
  height: 150px;
}
.path-2 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/path-002.png');
  left: 40px;
  top: 560px;
  z-index: 6;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 49px;
  height: 150px;
}
.green-circle {
  position: absolute;
  top: 10px;
  left: 80px;
  height: 240px;
  width: 240px;
  background-color: #66d162;
  border-radius: 50%;
}
.blue-circle {
  position: absolute;
  top: 360px;
  left: 320px;
  height: 130px;
  width: 130px;
  background-color: #5087ef;
  border-radius: 50%;
}
.hiw-phone {
  height: 420px;
}
.hiw-phone-img {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-012.png');
  left: 100px;
  top: 30px;
  z-index: 6;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 330px;
  height: 485px;
}
.blue-rounded {
  position: absolute;
  left: 110px;
  width: 220px;
  height: 220px;
  z-index: 6;
  border: solid 5px #20409a;
  border-radius: 50%;
}
.hiw-lock {
  height: 240px;
}
.hiw-ellipse-img {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/ellipse-01.png');
  left: 120px;
  top: 15px;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 220px;
  height: 220px;
}
.hiw-lock-img {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/lock.png');
  left: 180px;
  top: 40px;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 90px;
  height: 120px;
}

@media screen and (max-width: 1236px) {
  .hiw-home-img-1 {
    left: 100px;
    width: 320px;
    height: 270px;
  }
  .hiw-home-img-2 {
    left: 330px;
    top: 50px;
    width: 250px;
    height: 180px;
  }
  .hiw-steps-img-1 {
    left: 70px;
    top: 40px;
    width: 320px;
    height: 210px;
  }

  .hiw-steps-img-2 {
    left: 70px;
    top: 310px;
    width: 320px;
    height: 100px;
  }
  .hiw-steps-img-3 {
    left: 70px;
    top: 470px;
    width: 320px;
    height: 210px;
  }
  .green-rounded-1 {
    left: 270px;
    top: 150px;
    width: 220px;
    height: 85px;
  }
  .green-rounded-2 {
    left: 0;
    top: 420px;
    width: 220px;
    height: 85px;
  }
  .green-rounded-3 {
    left: 270px;
    top: 580px;
    width: 220px;
    height: 85px;
  }
  .path-1 {
    left: 400px;
    top: 270px;
    width: 39px;
    height: 120px;
  }
  .path-2 {
    left: 20px;
    top: 500px;
    width: 39px;
    height: 120px;
  }
}

@media screen and (max-width: 991px) {
  .hiw-home-img-1 {
    left: 10px;
    width: 250px;
    height: 240px;
  }
  .hiw-home-img-2 {
    left: 140px;
    top: 40px;
    width: 240px;
    height: 160px;
  }

  .hiw-steps-img-1 {
    left: 20px;
    top: 40px;
    width: 320px;
    height: 210px;
  }

  .hiw-steps-img-2 {
    left: 20px;
    top: 310px;
    width: 320px;
    height: 100px;
  }
  .hiw-steps-img-3 {
    left: 20px;
    top: 470px;
    width: 320px;
    height: 210px;
  }
  .green-rounded-1 {
    left: 180px;
    top: 170px;
    width: 220px;
    height: 85px;
  }
  .green-rounded-3 {
    left: 180px;
    top: 580px;
    width: 220px;
    height: 85px;
  }
  .path-1 {
    left: 345px;
    top: 270px;
    width: 39px;
    height: 120px;
  }
  .path-2 {
    left: 0px;
    top: 500px;
    width: 39px;
    height: 120px;
  }

  .green-circle {
    top: 10px;
    left: 80px;
    height: 160px;
    width: 160px;
  }
  .blue-circle {
    top: 280px;
    left: 270px;
    height: 100px;
    width: 100px;
  }
  .hiw-phone {
    height: 340px;
  }
  .hiw-phone-img {
    left: 100px;
    top: 30px;
    width: 230px;
    height: 385px;
  }
}

@media screen and (max-width: 768px) {
  .hiw-home {
    height: 280px;
  }
  .hiw-home-1 {
  }
  .hiw-home-img-1 {
    left: 20px;
    width: 300px;
    height: 250px;
    /* left: 0;
        right:0;
        margin-right: auto;
        margin-left: auto; */
  }
  .vp-middle {
    height: 650px;
  }
  .hiw-home-img-2 {
    left: 220px;
    top: 90px;
    width: 240px;
    height: 160px;
  }
  .hiw-steps-img-1 {
    left: 50px;
    top: 40px;
    width: 320px;
    height: 210px;
  }

  .hiw-steps-img-2 {
    left: 50px;
    top: 310px;
    width: 320px;
    height: 100px;
  }
  .hiw-steps-img-3 {
    left: 50px;
    top: 470px;
    width: 320px;
    height: 210px;
  }
  .green-rounded-1 {
    left: 270px;
    top: 150px;
    width: 220px;
    height: 85px;
  }
  .green-rounded-2 {
    left: 0;
    top: 420px;
    width: 220px;
    height: 85px;
  }
  .green-rounded-3 {
    left: 270px;
    top: 580px;
    width: 220px;
    height: 85px;
  }
  .path-1 {
    left: 380px;
    top: 270px;
    width: 39px;
    height: 120px;
  }
  .path-2 {
    left: 0px;
    top: 500px;
    width: 39px;
    height: 120px;
  }
  .green-circle {
    top: 10px;
    left: 80px;
    height: 160px;
    width: 160px;
  }
  .blue-circle {
    top: 280px;
    left: 270px;
    height: 100px;
    width: 100px;
  }
  .hiw-phone {
    height: 340px;
  }
  .hiw-phone-img {
    left: 100px;
    top: 30px;
    width: 230px;
    height: 385px;
  }
  .blue-rounded {
    left: 120px;
    width: 200px;
    height: 200px;
  }
  .hiw-lock {
    height: 200px;
  }
  .hiw-ellipse-img {
    left: 130px;
    top: 15px;
    width: 200px;
    height: 200px;
  }
  .hiw-lock-img {
    left: 175px;
    top: 35px;
    width: 90px;
    height: 120px;
  }
}

@media screen and (max-width: 520px) {
  .hiw-home {
    height: 150px;
  }
  .hiw-home-1 {
  }
  .hiw-home-img-1 {
    left: 20px;
    width: 200px;
    height: 170px;
    /* left: 0;
        right:0;
        margin-right: auto;
        margin-left: auto; */
  }
  .vp-middle {
    height: 450px;
  }
  .hiw-home-img-2 {
    left: 120px;
    top: 70px;
    width: 190px;
    height: 140px;
  }
  .hiw-steps-img-1 {
    left: 15px;
    top: 0px;
    width: 250px;
    height: 160px;
  }

  .hiw-steps-img-2 {
    left: 15px;
    top: 200px;
    width: 250px;
    height: 75px;
  }
  .hiw-steps-img-3 {
    left: 15px;
    top: 320px;
    width: 250px;
    height: 160px;
  }
  .green-rounded-1 {
    left: 100px;
    top: 120px;
  }
  .green-rounded-2 {
    left: -25px;
    top: 290px;
  }
  .green-rounded-3 {
    left: 100px;
    top: 410px;
  }
  .path-1 {
    left: 270px;
    top: 190px;
    width: 29px;
    height: 90px;
  }
  .path-2 {
    left: -10px;
    top: 360px;
    width: 29px;
    height: 90px;
  }
  .green-circle {
    left: 30px;
  }
  .blue-circle {
    left: 220px;
  }
  .hiw-phone {
    height: 300px;
  }
  .hiw-phone-img {
    left: 50px;
  }
  .blue-rounded {
    left: 70px;
    width: 200px;
    height: 200px;
  }
  .hiw-lock {
    height: 120px;
  }
  .hiw-ellipse-img {
    left: 85px;
  }
  .hiw-lock-img {
    left: 125px;
  }
}
</style>
